





import Vue from 'vue';
import Spinner from 'vue-simple-spinner';

export default Vue.extend({
    name: 'OverlaySpinner',
    components: { Spinner },
    props: {
        size: {
            type: [Number, String],
            required: false
        }
    }
});

